<template>
  <span>{{ finalformat }}</span>
</template>

<script>
/*
 ** 有 HHH(总小时) 请别使用 HH、MMM
 ** 有 MMM(总分钟) 请别使用 HHH、HH、MM、SSS
 ** 有 SSS(总秒数) 请别使用 HHH、HH、MMM、MM、SS
 */
import { secondsToHours, secondsToMinutes } from 'date-fns';

export default {
  props: {
    times: {
      required: true,
      type: Number,
      default: 0,
    },
    format: {
      type: String,
      default: 'MMM:SS',
    },
  },
  data() {
    return {
      seconds: 0,
      timing: true,
    };
  },
  computed: {
    finalformat() {
      const SSS = parseInt(this.seconds, 10);
      const SS = SSS % 60;
      const MMM = secondsToMinutes(SSS);
      const MM = MMM % 60;
      const tf = num => (num < 10 ? '0' : '') + num;
      return this.format.replace(/MMM|MM|SSS|SS/g, str => {
        switch (str) {
          case 'MMM':
            return tf(MMM);
          case 'MM':
            return tf(MM);
          case 'SSS':
            return tf(SSS);
          case 'SS':
            return tf(SS);
          default:
            return '';
        }
      });
    },
  },
  watch: {
    times: {
      handler(val) {
        this.seconds = val;
        if (!process.env.SERVER) this.startTick();
      },
      immediate: true,
    },
  },
  mounted() {},
  beforeDestroy() {
    this.timing = false;
  },
  methods: {
    startTick() {
      clearTimeout(this.timer);
      this.timer = setInterval(() => {
        this.seconds -= 1;
        if (!this.timing) clearTimeout(this.timer);
        if (this.seconds <= 0) {
          this.seconds = 0;
          clearTimeout(this.timer);
          this.$emit('onEnd');
        }
      }, 1000);
    },
  },
};
</script>
